import { createStyles, FullToken } from 'antd-style'

export const useStyles = createStyles(
  (
    { token },
    props: {
      size: number | undefined
      weight: number | undefined
      color: keyof FullToken | undefined
    }
  ) => ({
    text: {
      fontSize: `${props.size || 14}px`,
      fontWeight: `${props.weight || 400}`,
      color:
        props?.color && ((token[props?.color] || token.colorTextBase) as string)
    }
  })
)
